export class ChTaskTypes {

    static PkPerformerTaskTypeID = "2b11f708-441f-462e-b6ab-0cba1a077d47";
    static PkRejectApprovalTypeID = "fc8fb668-5ca4-4c9a-81b6-ed3092425e4c";
    static PkStartAgreementProcessTypeID = "71eff303-6c52-44b7-9c50-fb161cc0875b";
    static PkRdndUdoTaskTypeID = "568721da-cc11-44c7-b0c5-d8a47872550c";
    static PkConsiderationTypeID = "e230b87d-d837-4448-bcd3-a018acdda81b";
    static PkUksApprovalTaskTypeID = "e135de09-4f50-4d2b-b29b-11ccde5aaefc";
    static PkProjectGroupApprovalTaskTypeID = "a5d25a39-042a-4bbb-93cf-2cbbe3924fd0";
    static PkGipApprovalTaskTypeID = "5f132e2c-0e77-49c2-9cc1-6623b332ba98";
    static PkOspApprovalTaskTypeID = "f3562560-8d12-4efe-8471-57b5a726c984";
    static PkDepProductApprovalTaskTypeID = "ca4842e0-3f6f-429b-990e-4c78413e2221";
    static PkExternalApprovalTaskTypeID = "a840f4f8-433a-42fd-8428-833c162de75b";
    static PkApproversAgreementTypeID = "945b9439-0008-4d22-a3c3-003d1f05ae1b";
    static PkApprovalTerminationTypeID = "915a02b9-ea8f-4f28-924c-24218ad560B7";
    static PkApprovalLawyerTypeID = "84a30847-dcae-42d9-805d-33fe6d6dd0aa";
    static PkApprovalOfTopsTypeID = "96b2afe8-3988-417b-a10b-bbd1899945fb";
    static PkOSSEmployeeCommentTypeID = "9e3e26af-a5e8-4cc4-88fd-b095c979d7b1";
    static PkRefundDDYTypeID = "820b46bc-7d6d-4613-94d3-9618f9549c65";
    static PkRevaluationTypeID = "5d7c5f5d-6c35-4249-9e98-83acb35a524b";
    static PkSendingByPostTypeID = "11c33723-f8a2-4961-83ae-575f284db265";
    static PkEditTypeID = "a0844e7b-c0c2-4627-9d8c-4693c7a8d043";
    static PkReviewLawyerTypeID = "a98c998f-c277-4389-b6ef-1eec6025aeab";
    static PkCheckCustomerDecisionTypeID = "dbe8c80d-0a21-4ddb-8cf4-96e146594be9";
    static PkRevaluationForPDKPTypeID = "0ac01ea0-f316-476e-83cf-b2e4e3c96428";
    static PkApprovalByCoordinator = "22fe6d78-ed4c-4eae-aee1-161245e53748";
    static PkStartPerformanceProcessTaskTypeID = "4AF6051D-14BE-457C-941D-224344E1A7D2";
    static PkSignerAgreementTypeID = "DB4EE9F6-979A-46C6-B1E2-337299C0E2E8";
    static PkAcceptPackageOfDocumentsTypeID = "64f1df62-f840-4d32-b637-88c4bfb27412";
    static PkSendAPackageOfDocumentsTypeID = "4f71b6e1-969e-4bb8-a4e1-37a19c303767";
    static PkRegisterFirstTastTypeID = "cfc05f7a-b38f-4275-ba09-cf2f1161150b";
    static PkReviewOutgoingTypeID = "1876268f-ba04-4305-84af-4a01acaeffdc";
    static PkSignTypeSelectingTypeID = "b8063ff9-14b3-47c3-8087-9f5472e34565";
    static PkSendToContractorTypeID = "de059f98-a7f1-4f33-b45e-57bedb4eaf5d";
    static PkSignerDiadocTypeID = "64DF2A78-2445-41F1-A199-1C328A718034";
  }